import React, { Component } from 'react';
import people from "../../Images/People.png";
import memberlogo from "../../Images/Member-logo.png";
import find from "../../Images/find.png";
import exam from "../../Images/Exam.png";
import { tarbookService } from '../../services/tarbook.service';
import { historypush } from '../../_helpers/utilities';
import Loader from '../../_helpers/Loader';
import cardFDlogo from "../../Images/id-card.png";
import viewstudent from "../../Images/viewstudent.png";

class admindashboard extends Component {
    constructor(props) {
        super(props);
        this.state = { 
          isLoading:false,
          memberCount:0,
          userCount:0,
          roleId:0,
          code:0,
        };
    }

    componentDidMount=async()=>{
      this.setState({
          isLoading:true,
      })

      localStorage.removeItem("EditMemberId");
      localStorage.removeItem("EditUserId");
      const userID = localStorage.getItem("UserID");
      const grade = localStorage.getItem("Grade");
      localStorage.setItem("StudentDetails","Hide");
      const Role = localStorage.getItem("RoleId");
      if(Role != 1 && Role != 4){
        document.getElementById("show-admindashboard").style.display = 'none';
      }
      const usercode = localStorage.getItem("Code")

      if(usercode != undefined){
        this.setState({
          code : usercode,
        })
      }

      this.setState({roleId:Role})

      if(Role == 1 || Role == 4){
        var response=await tarbookService.GetDashboardDetails(userID,grade);
        if(response.status===200){
            this.setState({
                memberCount : response.data.memberCount,
                userCount : response.data.userCount,
                isLoading:false,
            })
        }else if(response.status===401){
          localStorage.clear();
            historypush('/login');
        }
      }else{
        historypush('/login');
      }
  }

  studentClick=()=>{
    localStorage.setItem("StudentDetails","Show");
    historypush('/details');
  }
    render() {
      const{
          memberCount,
          userCount,
          isLoading,
          code,
          roleId
      }=this.state;
        return (
          <div className="member-body" id="show-admindashboard">
            {isLoading && <Loader />}
          <div className="about">
            <div className="container">
              <h3 className="heading">IME(I) Administration Area</h3>
              <div className="row info-data">
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="boxed">
                    <div className="table-responsive-sm">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td colSpan={1}><img src={memberlogo} alt="group-member" className="member" /></td>
                            <td className="src-people" style={{textAlign: 'center', width: '20%'}} colSpan={1}>
                            <a style={{textDecoration:'none',color:'black'}} href='/details'><div><img src={people} alt="people" /></div>
                              <h6>View Members</h6></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="table-responsive-sm mbr-report-data">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td className="mbr-data">
                              <h4>Manage Members</h4>
                              <h5>Member Portal</h5>
                            </td>
                            <td className="mbr-report green-color admin-green">
                              <h2 style={{padding: '3px', fontSize: '30px', color:'#8BB700'}}>
                                {memberCount}
                                <p style={{fontSize: '15px', color: '#444054'}}>Total Members</p>
                              </h2>
                            </td>
                            <td className="mbr-report black-color">
                            <a style={{textDecoration:'none',color:'black'}} href='/memberregistration'>
                              <h5 style={{fontSize: '17px'}} className="mbrreport-data">Add New Member</h5>
                            </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="boxed">
                    <div className="table-responsive-sm">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td colSpan={1}><img src={cardFDlogo} alt="student" style={{width: '74px'}} className="member" /></td>
                            {/* <td colSpan={1}><img src={memberlogo} alt="student" style={{width: '74px'}} className="member" /></td> */}
                            <td className="src-people" style={{textAlign: 'center', width: '20%'}} colSpan={1}>
                            <a style={{textDecoration:'none',color:'black',cursor:'pointer'}} onClick={()=>this.studentClick()}>
                              <div><img src={viewstudent} alt="student" /></div>
                              <h6>View Students</h6>
                            </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="table-responsive-sm mbr-report-data">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td className="mbr-data">
                              <h4>Manage Students</h4>
                              <h5>Student Portal</h5>
                            </td>
                            <td className="mbr-report green-color admin-green">
                              <h2 style={{padding: '3px', fontSize: '30px', color:'#8BB700'}}>
                                {userCount}
                                <p style={{fontSize: '15px', color: '#444054'}}>Total Students</p>
                              </h2>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {roleId == 1?
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div className="boxed">
                    <div className="table-responsive-sm">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td colSpan={1} style={{width: '50%'}}>
                              <img src={exam} alt="exam" />
                            </td>
                            <td className="src-people" style={{textAlign: 'center', width: '20%'}} colSpan={1}>
                            <a style={{textDecoration:'none',color:'black'}} href='/adminquestionbank'>
                              <div><img src={find} alt="view" /></div>
                              <h6>View Question Bank</h6>
                            </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table className="table" style={{marginBottom: '0px'}}>
                        <tbody>
                          <tr>
                            <td className="mbr-data" style={{width: '65%'}}>
                              <h4>Manage Question Bank</h4>
                            </td>
                            <td className="mbr-report black-color">
                            <a style={{textDecoration:'none',color:'black'}} href='/adminquestionbank'>
                              <h5 style={{fontSize: '17px'}} className="addquestion-data">Add New Question</h5>
                            </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                :""}
              </div>
            </div>
          </div>
        </div>
        );
    }
}

export default admindashboard;